module.exports = __webpack_public_path__ + "static/media/shoes.837726a4.jpeg";